import React, { FC, ChangeEventHandler } from "react";
import styled, { css } from "styled-components";
import AnimateHeight from "react-animate-height";
import InputMask from "react-input-mask";

import { inputStyle } from "./styles";
import { RED, GREEN } from "../styles/constants";
import { easeOut, easeIn } from "../styles/atoms";

interface Props {
  id: string;
  value: string;
  name: string;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  onClick?: any;
  onBlur?: any;
  icon?: any;
  autoComplete?: string;
  disabled?: boolean;
  error?: boolean;
  errorMessage?: string;
  success?: boolean;
  successMessage?: string;
  mask?: string;
  placeholder?: string;
}
const TextInput: FC<Props> = ({
  children,
  disabled,
  mask,
  error,
  errorMessage,
  success,
  successMessage,
  placeholder,

  ...props
}) => {
  let inputEl = (
    <Input placeholder={placeholder} {...props} disabled={disabled} />
  );

  if (mask) {
    inputEl = (
      <InputMask
        mask={mask}
        maskChar={""}
        placeholder={placeholder || mask}
        {...props}
      >
        {(maskProps) => <Input {...maskProps} />}
      </InputMask>
    );
  }

  return (
    <Container>
      <WrraperInput disabled={disabled}>
        {inputEl}
        {children}
      </WrraperInput>
      {errorMessage && (
        <AnimateHeight height={error ? "auto" : 0}>
          <ErrorMessage error={error}>{errorMessage}</ErrorMessage>
        </AnimateHeight>
      )}
      {successMessage && (
        <AnimateHeight height={success ? "auto" : 0}>
          <SuccessMessage success={success}>{successMessage}</SuccessMessage>
        </AnimateHeight>
      )}
    </Container>
  );
};

const Container = styled.div`
  position: relative;
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px #f5f4f0 inset !important;
    box-shadow: 0 0 0 30px #f5f4f0 inset !important;
  }
`;

const WrraperInput = styled.div<any>`
  ${({ error }) => inputStyle({ error })};
  position: relative;
  font-size: 18px;
  ${({ disabled }) =>
    disabled
      ? css`
          input {
            background: #e3e3e3;
            pointer-events: none;
          }
        `
      : css``}
`;

const Input = styled.input<Props>`
  background: transparent;
  border-radius: 10px;
  padding: ${({ icon }) => (icon ? "10px 15px 10px 45px" : "10px 15px")};
  background: ${({ icon }) =>
    icon ? `url(${icon}) no-repeat 15px center` : "none"};
  border: none;
  width: 100%;
  height: 100%;

  &:disabled {
    background: #e3e3e3;
  }
`;

interface ErrorMessageInterface {
  error?: boolean;
}
const ErrorMessage = styled.p<ErrorMessageInterface>`
  margin: 0;
  padding-top: 0.25em;
  color: ${RED};
  opacity: ${({ error }) => (error ? 1 : 0)};
  ${({ error }) => (error ? easeOut : easeIn)};
  transition-delay: ${({ error }) => (error ? "0s" : ".2s")};
`;

interface SuccessMessageInterface {
  success?: boolean;
}
const SuccessMessage = styled.p<SuccessMessageInterface>`
  margin: 0;
  padding-top: 0.25em;
  color: ${GREEN};
  opacity: ${({ success }) => (success ? 1 : 0)};
  ${({ success }) => (success ? easeOut : easeIn)};
  transition-delay: ${({ success }) => (success ? "0s" : ".2s")};
`;

export default TextInput;
